import { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { connectSocket, disconnectSocket, getSocket } from '../services/socket';

const SocketContext = createContext(null);

export function SocketProvider({ children }) {
  const { user, token } = useAuth();
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!user || !token) {
      disconnectSocket();
      setConnected(false);
      return;
    }

    const socket = connectSocket();

    socket.on('connect', () => {
      setConnected(true);
      if (user.role === 'admin' || user.role === 'tech_support') {
        socket.emit('join:admin');
      }
      socket.emit('join:org', user.organization?.id || user.organizationId);
    });

    socket.on('disconnect', () => setConnected(false));

    return () => {
      disconnectSocket();
      setConnected(false);
    };
  }, [user, token]);

  return (
    <SocketContext.Provider value={{ socket: getSocket(), connected }}>
      {children}
    </SocketContext.Provider>
  );
}

export function useSocket() {
  return useContext(SocketContext);
}
